<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT">Contents</p>
<p class="CON1" id="toc1"><a href="#/Wolterstorff_The_God_We_Worship_text_CC5#_idTOCAnchor-1">Series Foreword</a></p>
<p class="CON1" id="toc2"><a href="#/Wolterstorff_The_God_We_Worship_text_CC6#_idTOCAnchor-2">Acknowledgments</a></p>
<p class="CON1" id="toc3"><a href="#/Wolterstorff_The_God_We_Worship_text_CC7#_idTOCAnchor-3">1. The Project: Liturgical Theology</a></p>
<p class="CON1" id="toc4"><a href="#/Wolterstorff_The_God_We_Worship_text_CC8#_idTOCAnchor-4">2. God as Worthy of Worship</a></p>
<p class="CON1" id="toc5"><a href="#/Wolterstorff_The_God_We_Worship_text_CC9#_idTOCAnchor-5">3. God as One Who Is Vulnerable</a></p>
<p class="CON1" id="toc6"><a href="#/Wolterstorff_The_God_We_Worship_text_CC10#_idTOCAnchor-6">4. God as One Who Participates in Mutual Address</a></p>
<p class="CON1" id="toc7"><a href="#/Wolterstorff_The_God_We_Worship_text_CC11#_idTOCAnchor-7">5. God as One Who Listens</a></p>
<p class="CON1" id="toc8"><a href="#/Wolterstorff_The_God_We_Worship_text_CC12#_idTOCAnchor-8">6. What Are We Saying <br/>When We Say That God Listens?</a></p>
<p class="CON1" id="toc9"><a href="#/Wolterstorff_The_God_We_Worship_text_CC13#_idTOCAnchor-9">7. God as One Who Hears Favorably</a></p>
<p class="CON1" id="toc10"><a href="#/Wolterstorff_The_God_We_Worship_text_CC14#_idTOCAnchor-10">8. God as One Who Speaks</a></p>
<p class="CON1" id="toc11"><a href="#/Wolterstorff_The_God_We_Worship_text_CC15#_idTOCAnchor-11">9. The Understanding of God Implicit in the Eucharist</a></p>
<p class="CON1" id="toc12"><a href="#/Wolterstorff_The_God_We_Worship_text_CC16#_idTOCAnchor-12">Afterword</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wolterstorff_The_God_We_Worship_text_CC-3.vue?e07089fa